module.exports = __webpack_public_path__ + "img/success.e7706e62.png";